import { useEffect, useRef, useState } from "react";
import { GraphQLResult, GRAPHQL_AUTH_MODE } from "@aws-amplify/api-graphql";
import { API } from "aws-amplify";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppSelector } from "../../app/hooks";
import AppLocale from "../../lang";
import {
  Localization,
  selectTheme,
  showFooter,
  showLoading,
  showLoginPopup,
  ThemeMode,
} from "../../features/theme/themeSlice";
import {
  PlayerMode,
  selectPlayer,
  updateAccount,
} from "../../features/player/playerSlice";
import {
  CheckAccountStateQuery,
  Game,
  GenerateGameSessionTokenTimelessTechMutation,
  GetGameByIdQuery,
  SessionManagementMutation,
} from "../../API";
import {
  generateGameSessionTokenTimelessTech,
  sessionManagement,
} from "../../graphql/mutations";

import { checkAccountState, getGameById } from "../../graphql/queries";
import useAccount from "../../hooks/useAccount";

import { selectConfig } from "../../features/configapp";

type LocationState = {
  gameId: string;
};

const Horseracing: React.FC = () => {
  const sessionRef = useRef();
  const dispatch = useDispatch();
  const theme = useAppSelector(selectTheme);
  const locale: Localization = theme.language as any;
  const languages: any = { it: "it-IT", en: "en-US" };
  const language = languages[locale];
  const currentAppLocale = AppLocale[locale];
  const config = useAppSelector(selectConfig);
  const location = useLocation();
  const locationState = location.state as LocationState;
  const [gameId, setGameId] = useState(45800);
  const [gameProvider, setGameProvider] = useState(
    "b45e31ed-d54b-40fe-9fda-c208ff5502f7"
  );
  const [sessionToken, setSessionToken] = useState(null);
  sessionRef.current = sessionToken;
  const [game, setGame] = useState<Game | null>(null);
  const navigate = useNavigate();
  const { accountBalance, accountRefresh } = useAccount();

  const player = useAppSelector(selectPlayer);

  const closeSession = (
    sessionToken: string,
    callback: (result: any) => void
  ) => {
    (async () => {
      const result: GraphQLResult<SessionManagementMutation> =
        (await API.graphql({
          query: sessionManagement,
          authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
          variables: {
            session: sessionToken,
            oper: "SESSION_CLOSE",
          },
        })) as GraphQLResult<SessionManagementMutation>;
      if (result.data.sessionManagement) {
        return result.data.sessionManagement;
      } else return null;
    })().then((r) => {
      if (callback) {
        callback(r);
      }
    });
  };

  const generateSession = (amount: number) => {
    (async () => {
      try {
        const result: GraphQLResult<GenerateGameSessionTokenTimelessTechMutation> =
          (await API.graphql({
            query: generateGameSessionTokenTimelessTech,
            authMode: player.logged
              ? GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS
              : GRAPHQL_AUTH_MODE.AWS_IAM,
            variables: {
              currency: player.account ? player.account.valute : "EUR",
              lang: language,
              gameId: `${gameProvider}#${gameId}`,
              buyIn: amount,
              category: "Turf",
            },
          })) as GraphQLResult<GenerateGameSessionTokenTimelessTechMutation>;

        if (result.data.generateGameSessionTokenTimelessTech.length > 20)
          setSessionToken(result.data.generateGameSessionTokenTimelessTech);
      } catch (e) {
        console.error(e);
      }
    })();
  };

  useEffect(() => {
    if (gameId) {
      (async () => {
        const result: GraphQLResult<GetGameByIdQuery> = (await API.graphql({
          query: getGameById,
          authMode: player.logged
            ? GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS
            : GRAPHQL_AUTH_MODE.AWS_IAM,
          variables: {
            gameId: `${gameProvider}#${gameId}`,
          },
        })) as GraphQLResult<GetGameByIdQuery>;

        if (result.data.getGameById) {
          console.log(result);
          setGame(result.data.getGameById);
        }
      })();
    }
  }, [gameId]);

  useEffect(() => {
    console.log("virtual", player);
    dispatch(showFooter(false));
    dispatch(showLoading(true));
    if (!player.account) {
      if (!player.logged) {
        dispatch(showLoginPopup(true));
        dispatch(showLoading(false));
      } else {
        (async () => {
          try {
            generateSession(accountBalance);
          } catch (reason) {
            dispatch(showLoginPopup(true));
            dispatch(showLoading(false));
          }
        })().catch((reason) => {
          console.log(reason);
        });
      }

      dispatch(showLoading(false));
    } else {
      dispatch(showLoading(false));
      generateSession(accountBalance);
    }

    return () => {
      dispatch(showLoading(false));
      console.log("session close", sessionRef.current);
      closeSession(sessionRef.current, (r) => {
        accountRefresh();
      });
    };
  }, []);

  return (
    <div className="d-sport">
      {game && sessionToken && (
        <iframe
          loading="eager"
          onLoad={() => {
            dispatch(showLoading(false));
          }}
          src={`
			${
        game.gameLaunchUrl
      }/?mode=real&lobby_id=${"pferdewetten"}&token=${sessionToken}&currency=${
            player.account.valute
          }&language=${language}&operator_id=${config.config.timelesstechOperatorId}&home_url=${config.config.home_url}`}
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            border: "none",
            outline: "none",
          }}
        />
      )}
    </div>
  );
};

export default Horseracing;
